var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var LogPurchasingBlock = /** @class */ (function () {
    function LogPurchasingBlock(element) {
        this.defaultIdPattern = 'log-purchasing-block_';
        this.logPurchasingBlock = element;
        this.blockId = this.logPurchasingBlock.id;
        this.locationContainer = this.logPurchasingBlock.querySelector('.log-purchasing-locations');
        this.locationToggles = Array.from(this.locationContainer.querySelectorAll('.location'));
        this.listContainers = Array.from(this.logPurchasingBlock.querySelectorAll('.log-purchasing-list'));
        this.logPurchasingItems = Array.from(this.logPurchasingBlock.querySelectorAll('.log-purchasing-item'));
        this.init();
        this.addEventListeners();
    }
    LogPurchasingBlock.prototype.init = function () {
        var _this = this;
        // if block has unique id set
        if (!this.blockId.includes(this.defaultIdPattern)) {
            // wait for page to load
            window.addEventListener('load', function () { return _this.checkBodyClass().then(function (r) { return _this.urlCheck(); }); });
        }
    };
    // check for body to not contain no-scroll class
    LogPurchasingBlock.prototype.checkBodyClass = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!document.body.classList.contains('no-scroll')) return [3 /*break*/, 2];
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    LogPurchasingBlock.prototype.urlCheck = function () {
        // if block has unique id set
        var hash = window.location.hash;
        // if page has hash and hash includes block id
        if (hash && hash.includes(this.blockId)) {
            this.setAccordionFromUrl(hash);
            this.logPurchasingBlock.scrollIntoView({ behavior: 'smooth' });
        }
    };
    LogPurchasingBlock.prototype.setAccordionFromUrl = function (hash) {
        var accordionTarget = decodeURIComponent(hash.replace("#".concat(this.blockId, "-"), ''));
        var targetAccordionList = this.logPurchasingBlock.querySelector("[data-accordion-content=\"".concat(accordionTarget, "\"]"));
        var targetAccordionToggle = this.locationContainer.querySelector("[data-accordion-target=\"".concat(accordionTarget, "\"]"));
        this.locationToggles.forEach(function (accordionList) { return accordionList.classList.remove('active'); });
        targetAccordionToggle.classList.add('active');
        this.listContainers.forEach(function (accordionList) { return accordionList.classList.remove('active'); });
        targetAccordionList.classList.add('active');
    };
    LogPurchasingBlock.prototype.addEventListeners = function () {
        var _this = this;
        this.logPurchasingItems.forEach(function (logPurchasingItem) {
            var logPurchasingItemHeader = logPurchasingItem.querySelector('.log-purchasing-item-header');
            logPurchasingItemHeader.addEventListener('click', _this.toggleItem.bind(_this));
        });
        this.locationToggles.forEach(function (accordionTag) {
            accordionTag.addEventListener('click', _this.filterLocationItems.bind(_this));
        });
    };
    LogPurchasingBlock.prototype.toggleItem = function (event) {
        var currentElement = event.currentTarget;
        var item = currentElement.parentElement;
        var itemContainer = item.parentElement;
        var itemContentIsOpen = item.classList.contains('active');
        if (itemContentIsOpen) {
            item.classList.remove('active');
        }
        else {
            item.classList.add('active');
        }
    };
    LogPurchasingBlock.prototype.filterLocationItems = function (event) {
        var location = event.currentTarget;
        var accordionTarget = location.dataset.accordionTarget;
        // if block has unique id set
        if (!this.blockId.includes(this.defaultIdPattern)) {
            // add to url #purchasing-[accordionTarget
            window.location.hash = "#".concat(this.blockId, "-").concat(accordionTarget);
        }
        var targetAccordionList = this.logPurchasingBlock.querySelector("[data-accordion-content=\"".concat(accordionTarget, "\"]"));
        var locationIsActive = location.classList.contains('active');
        if (!locationIsActive) {
            this.locationToggles.forEach(function (accordionList) { return accordionList.classList.remove('active'); });
            location.classList.add('active');
            this.listContainers.forEach(function (accordionList) { return accordionList.classList.remove('active'); });
            targetAccordionList.classList.add('active');
        }
    };
    return LogPurchasingBlock;
}());
var logPurchasingBlocks = document.querySelectorAll('[data-log-purchasing-block]');
logPurchasingBlocks.forEach(function (logPurchasingBlock) {
    new LogPurchasingBlock(logPurchasingBlock);
});
